// Person id first: a spouse and a minor can share an email, and the first email
// hit would show the wrong application. Email remains the fallback when the lease
// link and the application are two prop_person rows for the same adult, and only
// when that email belongs to exactly one application on the lease.
export function matchLeaseApplication(applications, { email, personId } = {}) {
  const list = applications ?? [];
  const byPerson = personId && list.find(a => a.personId === personId);
  if (byPerson) return byPerson;
  const normalized = typeof email === 'string' ? email.toLowerCase() : '';
  if (!normalized) return null;
  const byEmail = list.filter(a => a.email?.toLowerCase() === normalized);
  return byEmail.length === 1 ? byEmail[0] : null;
}
